<template>
  <el-row :gutter="gutter" class="ui-row" style="margin-right:0;">
    <el-col :span="spanLabel" class="ui-col ui-row-label">{{
      row.label
    }}</el-col>
    <el-col :span="spanValue" class="ui-col ui-row-label" :style="cusStyle" v-if="disabled!='1'">
      <el-input type="textarea" v-model="row.value"></el-input>
    </el-col>
    <el-col :span="spanValue" class="ui-col ui-row-label"  style="background-color:#ebebe4" v-if="disabled=='1'">
      {{row.value}}
    </el-col>
    <el-col :span="spanButton" :style="btnGroupStyle">
      <slot></slot>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: "ui-row",
  props: {
    row: {
      type: Object,
      default: function() {
        return {
          label: "",
          value: ""
        };
      }
    },
    gutter: {
      type: Number,
      default: 20
    },
    spanLabel: {
      type: Number,
      default: 4
    },
    spanValue: {
      type: Number,
      default: 20
    },
    spanButton: {
      type: Number,
      default: 0
    },
    cusStyle: {
      type: String,
      default: ""
    },
    btnGroupStyle: {
      type: String,
      default: ""
    },
    disabled:{
      type: Number,
      default: 0
    }
  }
};
</script>

<style>
.ui-row:not(:last-of-type) {
  margin-bottom: 20px;
}

.ui-row .ui-col {
  padding: 5px;
  min-height: 30px;
}

.ui-row .ui-row-value {
  max-height: 20vh;
  border: 1px solid #d5d5d5;
  border-radius: 5px;
  word-break: break-word;
  overflow: auto;
}


</style>
<style scoped>

</style>
